import React from "react";

export const goalFilled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <g fill="currentColor">
        <path
          stroke="currentColor"
          strokeWidth=".5"
          d="M12 1.2a10.8 10.8 0 1 0 0 21.6 10.8 10.8 0 0 0 0-21.6Zm0 20.4a9.6 9.6 0 1 1 0-19.2 9.6 9.6 0 0 1 0 19.2Z"
        />
        <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2.55a7.45 7.45 0 0 0-6.883 4.598 7.451 7.451 0 0 0 9.734 9.735A7.45 7.45 0 0 0 17.268 6.73 7.45 7.45 0 0 0 12 4.55m-1.122 1.81A5.751 5.751 0 1 1 12 17.75a5.75 5.75 0 0 1-1.122-11.39M12 8.15a3.85 3.85 0 1 0 0 7.702 3.85 3.85 0 0 0 0-7.702m-.419 1.742a2.15 2.15 0 1 1 .84 4.219 2.15 2.15 0 0 1-.84-4.22" />
      </g>
    </svg>
  );
};
